import React from 'react';
import { IIconProps } from '../interfaces';

const AleaClipOpenIcon: React.FC<IIconProps> = ({
  color = '#2B4956',
  size = '105',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 105 113"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 83">
      <g id="Group">
        <path
          id="Vector"
          d="M12.626 5.30329L12.536 5.35329C3.036 10.9633 -0.733999 25.0233 4.116 36.7633L21.076 77.7633C22.666 81.6033 26.466 83.2233 29.576 81.3933L52.826 67.6733C55.936 65.8433 57.166 61.2433 55.576 57.4033L38.616 16.4033C33.766 4.66329 22.126 -0.29671 12.626 5.30329Z"
          stroke={color}
          strokeWidth="4"
        />
        <path
          id="Vector_2"
          d="M16.0768 12.9232C9.89682 16.5732 7.44682 25.7132 10.6068 33.3432L10.7968 33.8132C11.1268 34.6032 11.9068 34.9332 12.5468 34.5632L32.4568 22.8132C33.0968 22.4332 33.3468 21.4932 33.0268 20.7032L32.7568 20.0432C29.6468 12.5132 22.1868 9.33321 16.0868 12.9232H16.0768Z"
          stroke={color}
          strokeWidth="4"
        />
      </g>
      <g id="Group 82">
        <path
          id="Vector_3"
          d="M97.1065 105.624L97.1865 105.574C104.947 100.024 104.196 91.7636 95.6065 86.8236L63.9365 68.6436C60.8365 66.8636 55.9065 66.7536 52.9065 68.4336L29.1865 81.7635C25.8265 83.6535 25.9265 86.7036 29.4265 88.5436L65.0165 107.214C74.6265 112.254 89.0365 111.394 97.1065 105.624Z"
          stroke={color}
          strokeWidth="4"
        />
        <ellipse
          id="Ellipse 75"
          cx="53.9961"
          cy="86.8335"
          rx="3"
          ry="2"
          fill={color}
        />
        <ellipse
          id="Ellipse 76"
          cx="60.9961"
          cy="90.8335"
          rx="3"
          ry="2"
          fill={color}
        />
        <ellipse
          id="Ellipse 77"
          cx="64.9961"
          cy="80.8335"
          rx="3"
          ry="2"
          fill={color}
        />
        <ellipse
          id="Ellipse 78"
          cx="72.9961"
          cy="84.8335"
          rx="3"
          ry="2"
          fill={color}
        />
      </g>
    </g>
  </svg>
);

export default AleaClipOpenIcon;
